var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page flexcolumn" },
    [
      _c("div", { staticClass: "jp-common-layout " }, [
        _c(
          "div",
          {
            staticClass: "jp-common-layout-left",
            staticStyle: { width: "200px" },
          },
          [
            _c(
              "div",
              { staticClass: "jp-common-title flexTreeTitle" },
              [
                _c("el-input", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请输入关键字进行过滤",
                    size: "small",
                    clearable: "",
                  },
                  model: {
                    value: _vm.filterText,
                    callback: function ($$v) {
                      _vm.filterText = $$v
                    },
                    expression: "filterText",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "jp-common-el-tree-scrollbar el-scrollbar" },
              [
                _c(
                  "div",
                  {
                    staticClass: "el-scrollbar__wrap",
                    style: { height: _vm.treeHeight - 40 + "px" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "el-scrollbar__view" },
                      [
                        _c("el-tree", {
                          ref: "officeTree",
                          staticClass: "filter-tree jp-common-el-tree",
                          attrs: {
                            data: _vm.showTreeList,
                            props: {
                              value: "id", // ID字段名
                              label: "label", // 显示名称
                              children: "children", // 子级字段名
                            },
                            "node-key": "id",
                            "default-expand-all": "",
                            "filter-node-method": _vm.filterNode,
                            "expand-on-click-node": false,
                            "highlight-current": "",
                          },
                          on: { "node-click": _vm.handRow },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c(
          "div",
          { staticClass: "jp-common-layout-center jp-flex-main" },
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                staticClass: "query-form",
                attrs: { size: "small", inline: true, model: _vm.searchForm },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.refreshList()
                  },
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "nameEn" } },
                  [
                    _c("el-input", {
                      attrs: {
                        size: "small",
                        placeholder: "标签名称（英）",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchForm.nameEn,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "nameEn", $$v)
                        },
                        expression: "searchForm.nameEn",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-search",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.refreshList()
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", icon: "el-icon-refresh-right" },
                        on: {
                          click: function ($event) {
                            return _vm.resetSearch()
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticStyle: { float: "right" } },
                  [
                    _vm.hasPermission("cecunmtagcloud:cecUnmTagCloud:add")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.add()
                              },
                            },
                          },
                          [_vm._v("新建")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "bg-white top" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: {
                    height: "calc(100% - 30px)",
                    overflow: "auto",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.dataList, function (tag, index) {
                      return _c(
                        "el-tag",
                        {
                          key: index,
                          staticClass: "singleTag",
                          attrs: {
                            closable: _vm.hasPermission(
                              "cecunmtagcloud:cecUnmTagCloud:del"
                            ),
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleCloseTag(tag)
                            },
                          },
                        },
                        [
                          _vm._v(" " + _vm._s(tag.nameEn) + " "),
                          _vm.hasPermission(
                            "cecunmtagcloud:cecUnmTagCloud:edit"
                          )
                            ? _c("i", {
                                staticClass: "el-icon-edit iconEdit",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.edit(tag.id)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    }),
                    1
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("CecUnmTagCloudForm", {
        ref: "cecUnmTagCloudForm",
        on: { refreshDataList: _vm.refreshList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }